<button
  *ngIf="(entries$ | async)?.length > 0 && (entries$ | async) as entries"
  class="link cx-action-link"
  (click)="exportCsv(entries)"
>
  {{ 'exportEntries.exportToCsv' | cxTranslate }}
</button>
